// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__EQLve","header":"PatientQuestionnaire_header__3Xyew","info":"PatientQuestionnaire_info__fY8hA"};